/*
 * Copyright (c) 2026 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, July 31st 2026, 4:03:28 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import ListItemText from "@mui/material/ListItemText";
import { USER_TYPES } from "lib/schemas";
import { CheckBoxSelector } from "ui-widgets";

type UserTypeMultiCheckBoxSelectorProps = {
  options?: (keyof typeof USER_TYPES)[];
  selectedUserTypes: (keyof typeof USER_TYPES)[];
  userTypesDisplay?: Partial<Record<keyof typeof USER_TYPES, { label: string; description: string }>>;
  onSelectUserType: (userType: keyof typeof USER_TYPES) => void;
};

export const UserTypeMultiCheckBoxSelector = ({
  onSelectUserType,
  selectedUserTypes,
  userTypesDisplay,
  options = Object.keys(USER_TYPES) as any,
}: UserTypeMultiCheckBoxSelectorProps) => {
  return (
    <CheckBoxSelector<keyof typeof USER_TYPES>
      onClickItem={onSelectUserType}
      values={selectedUserTypes}
      options={options}
      getOptionLabel={(type) => {
        const label = userTypesDisplay?.[type]?.label || USER_TYPES[type];
        const description = userTypesDisplay?.[type]?.description || USER_TYPES[type];
        return <ListItemText primary={label} secondary={description} />;
      }}
    />
  );
};
